import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Injector,
  Input,
  Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

/**
 * Base class providing status update and blur subscription.
 */
@Directive()
export abstract class PatternlibControlValueAccessorCommonBase implements AfterViewInit, ControlValueAccessor {
  private onChange = (_: any) => {};
  private onTouched = () => {};
  protected control?: NgControl;

  protected lastValue: any;

  @Input() showSuccess = false;
  @Input() validateOnTouched = true;

  constructor(protected _renderer: Renderer2, protected _injector: Injector, protected _elementRef: ElementRef) {}

  ngAfterViewInit() {
    try {
      // despite Angular reports that there is a circular dependency, the NgControl is injected correctly
      this.control = this._injector.get(NgControl);
      if (!this.control) {
        console.warn("No control found for form control directive.");
      }
    }
    catch (e) {}
  }

  writeValue(value: any) {
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
  }

  /**
   * Writes value to the viewmodel (onChange).
   */
  protected handleChangeEvent(value: any) {
    if (value !== this.lastValue) {
      this.lastValue = value;
      this.onChange(value);
    }
  }

  @HostListener('focusout')
  @HostListener('blur')
  @HostListener('lhBlur')
  onBlur() {
    this.onTouched();
  }

  @HostBinding('attr.status')
  get getStatus() {
    if (!this.validateOnTouched || this.control?.touched || this.control?.dirty) {
      if (this.control?.invalid) return 'error';
      if (this.showSuccess && this.control?.valid) return 'success';
    }

    return 'default';
  }

  /**
   * Registers a function called when the control is touched.
   * @nodoc
   */
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  /**
   * Registers a function called when the control value changes.
   * @nodoc
   */
  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  /**
   * Sets the "disabled" property on the range input element.
   * @nodoc
   */
  setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }
}
